
import { Route } from "react-router-dom";
import { lazy, Suspense } from "react";

// Import product pages
const FixedUnitsGlazing = lazy(() => import("@/pages/FixedUnitsGlazing"));
const SlidingUnitsGlazing = lazy(() => import("@/pages/SlidingUnitsGlazing"));
const HingedUnitsGlazing = lazy(() => import("@/pages/HingedUnitsGlazing"));
const LiftOutUnitsGlazing = lazy(() => import("@/pages/LiftOutUnitsGlazing"));
const VerticalSlidingUnitsGlazing = lazy(() => import("@/pages/VerticalSlidingUnitsGlazing"));
const HorizontalSlidingUnitsGlazing = lazy(() => import("@/pages/HorizontalSlidingUnitsGlazing"));
const SecondaryGlazingImages = lazy(() => import("@/pages/SecondaryGlazingImages"));
const CaseStudies = lazy(() => import("@/pages/CaseStudies"));
const FAQ = lazy(() => import("@/pages/FAQ"));
const Portfolio = lazy(() => import("@/pages/Portfolio"));

export const productRoutes = [
  <Route key="fixed-units" path="/fixed-units-glazing" element={<FixedUnitsGlazing />} />,
  <Route key="sliding-units" path="/sliding-units-glazing" element={<SlidingUnitsGlazing />} />,
  <Route key="hinged-units" path="/hinged-units-glazing" element={<HingedUnitsGlazing />} />,
  <Route key="lift-out-units" path="/lift-out-units-glazing" element={<LiftOutUnitsGlazing />} />,
  <Route key="vertical-sliding" path="/vertical-sliding-units-glazing" element={<VerticalSlidingUnitsGlazing />} />,
  <Route key="horizontal-sliding" path="/horizontal-sliding-units-glazing" element={<HorizontalSlidingUnitsGlazing />} />,
  <Route key="glazing-images" path="/secondary-glazing-images" element={<SecondaryGlazingImages />} />,
  <Route key="case-studies" path="/case-studies" element={<CaseStudies />} />,
  <Route key="faq" path="/faq" element={<FAQ />} />,
  <Route key="portfolio" path="/portfolio" element={<Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading portfolio...</div>}><Portfolio /></Suspense>} />,
];
